const getters = {
  getData: state => state.data,
  getMessage: state => state.message
}

export default getters
